import { render } from "./ProjectUserPledge.vue?vue&type=template&id=7ef0537a"
import script from "./ProjectUserPledge.vue?vue&type=script&lang=js"
export * from "./ProjectUserPledge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__